"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.uploadConfig = exports.dummyUploadFile = exports.dummyDownloadFile = void 0;
const shortid_1 = __importDefault(require("shortid"));
const dummyDownloadFile = (digest) => Promise.resolve(new File([], digest));
exports.dummyDownloadFile = dummyDownloadFile;
const dummyUploadFile = () => async (file, onSuccess, onError, onProgress) => {
    const id = shortid_1.default.generate();
    const success = {
        id,
        name: file.name,
        digest: shortid_1.default.generate(),
        size: file.size,
        mimetype: file.type,
        downloadUri: file.name,
        createdAt: new Date(file.lastModified).toISOString()
    };
    const isError = false;
    // const realFileSize = file.size;
    const dummyFileSize = 600;
    const final = isError ? null : success;
    if (onProgress) {
        // eslint-disable-next-line no-plusplus
        for (let loaded = 0; loaded < dummyFileSize; loaded++) {
            // eslint-disable-next-line no-await-in-loop
            await new Promise(res => setTimeout(res, 1));
            onProgress({
                uploadBytes: loaded,
                uploadPercent: Math.round((loaded * 100) / dummyFileSize),
                totalPercent: 50 + Math.round((loaded * 50) / dummyFileSize)
            });
        }
    }
    if (isError)
        return onError(final);
    return onSuccess(final);
};
exports.dummyUploadFile = dummyUploadFile;
/**
 * Imported from media-api for testing the UI. This might not be current.
 */
exports.uploadConfig = {
    // Data Size Limit to upload files to S3 bucket
    MAX_FILE_SIZE: 1024 * 1024 * 100,
    // Files with an extensions not in this list should be rejected
    FILE_EXTENSION_WHITELIST_MAP: {
        documents: [
            'doc',
            'txt',
            'pdf',
            'xml',
            'dot',
            'eml',
            'json',
            'msg',
            'odt',
            'oft',
            'one',
            'pages',
            'rtf',
            'xps',
            'docm',
            'docx'
        ],
        images: ['jpg', 'png', 'gif', 'bmp', 'ico', 'jpeg', 'tif', 'tiff'],
        presentations: ['ppt', 'pptx', 'pps', 'ppsx'],
        spreadsheets: ['xls', 'csv', 'numbers', 'xlsm', 'xlsx'],
        archives: ['zip', 'rar', 'tar', 'gz', 'tgz', 'zipx']
    }
};
//# sourceMappingURL=media.js.map